import fp from 'lodash/fp';

export default function createReducer(initialState, handlers) {
  return function reducer(state = initialState, action) {
    if (fp.has(action.type, handlers)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}
